// Source strings are written to every Firestore document.
// NEVER change a value once data has been written — it is a Firestore filter key.
// Key format: SHORTNAME_MON_YYYY — mirrors the EVENTS key in events.js
// To add a new event: add an entry here, then reference it in events.js

export const SOURCES = {
  ZOOM_JAN_2026: {
    registration: 'zoom-registration-jan-2026',
    feedback: 'zoom-feedback-jan-2026'
  },
  VALENTINES_FEB_2026: {
    registration: 'valentines-registration-feb-2026',
    feedback: 'valentines-feedback-feb-2026'
  },
  WOMENS_MAR_2026: {
    registration: 'womens-registration-mar-2026',
    feedback: 'womens-feedback-mar-2026'
  },
  SOCIAL_APR_2026: {
    registration: 'social-registration-apr-2026',
    feedback: 'social-feedback-apr-2026'
  },
  CYBERSAFETY_AUG_2026: {
    registration: 'cyber-safety-registration-aug-2026',
    feedback: 'cyber-safety-feedback-aug-2026'
  },
  NOBARRIERS_AUG_2026: {
    registration: 'no-barriers-registration-aug-2026',
    feedback: 'no-barriers-feedback-aug-2026'
  },
  WIREDFORLOVE_OCT_2026: {
    registration: 'wired-for-love-registration-oct-2026',
    feedback: 'wired-for-love-feedback-oct-2026'
  },
  WOMENWEBINAR_NOV_2026: {
    registration: 'women-webinar-registration-nov-2026',
    feedback: 'women-webinar-feedback-nov-2026'
  }
};